import React from 'react'
import _ from 'lodash'
import { useSelector } from 'react-redux'

import * as InvoicesAndReceiptsConstants from '../helpers/constants'
import * as InvoicesAndReceiptsHelpers from './../helpers/helpers'
import ReceiptsTable from '../../../../tables/invoices_and_receipts/receipts'
import { CLIENTS } from '../../../../../helpers/constants'

const BillingHistory = ({ receiptData, data, client }) => {

  // crm user data
  const jwtToken = useSelector((state) => state.user.jwtToken)
  const userName = useSelector((state) => state.user.name)
  const id = useSelector((state) => state.user.id)


  // the columns which needs additional states needs to be pushed from here
  // additional dependent columns
  const ADDITIONAL_DEPENDENT_COLUMNS = {
    [CLIENTS.CLEAROUT.NAME]: [
      {
        label: 'Download',
        renderCell: (receipt) => InvoicesAndReceiptsHelpers.invoiceAndReceiptDownloadFormatter(receipt, jwtToken, data, client),
        order: 12
      }
    ],
    [CLIENTS.CLEAROUTPHONE.NAME]: [
      {
        label: 'Download',
        renderCell: (receipt) => InvoicesAndReceiptsHelpers.copInvoiceAndReceiptDownloadFormatter(receipt, jwtToken, data, userName, id, client),
        order: 12
      }
    ],
    [CLIENTS.EU_CLEAROUTPHONE.NAME]: [
      {
        label: 'Download',
        renderCell: (receipt) => InvoicesAndReceiptsHelpers.copInvoiceAndReceiptDownloadFormatter(receipt, jwtToken, data, userName, id, client),
        order: 12
      }
    ],
    [CLIENTS.SPOKESLY_CLEAROUT.NAME]: [
      {
        label: 'Download',
        renderCell: (receipt) => InvoicesAndReceiptsHelpers.invoiceAndReceiptDownloadFormatter(receipt, jwtToken, data, client),
        order: 12
      }
    ],
    [CLIENTS.EU_CLEAROUT.NAME]: [
      {
        label: 'Download',
        renderCell: (receipt) => InvoicesAndReceiptsHelpers.invoiceAndReceiptDownloadFormatter(receipt, jwtToken, data, client),
        order: 12
      }
    ],
    [CLIENTS.PEPIPOST_CLEAROUT.NAME]: [
      {
        label: 'Download',
        renderCell: (receipt) => InvoicesAndReceiptsHelpers.invoiceAndReceiptDownloadFormatter(receipt, jwtToken, data, client),
        order: 12
      }
    ],
    [CLIENTS.CAMS_CLEAROUT.NAME]: [
      {
        label: 'Download',
        renderCell: (receipt) => InvoicesAndReceiptsHelpers.invoiceAndReceiptDownloadFormatter(receipt, jwtToken, data, client),
        order: 12
      }
    ],
    [CLIENTS.US_CLEAROUT.NAME]: [
      {
        label: 'Download',
        renderCell: (receipt) => InvoicesAndReceiptsHelpers.invoiceAndReceiptDownloadFormatter(receipt, jwtToken, data, client),
        order: 12
      }
    ],
  }

  let columns = InvoicesAndReceiptsConstants.RECEIPT_TABLE_COLUMNS[client]
  let additionalColumns = ADDITIONAL_DEPENDENT_COLUMNS[client]

  columns = _.concat([], columns, additionalColumns)
  columns = _.sortBy(columns, 'order')

  return (
    <>
      <h5 className='billing-tab-headers mt-4'>Billing Details</h5 >
      <ReceiptsTable
        data={receiptData}
        columns={columns}
      />
    </>
  )
}

export default BillingHistory
